import React, { useEffect, useRef } from "react";
import bgMusic from "../assets/background.mp3";

const BackgroundAudio = () => {
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = audioRef.current;

    const handleUserInteraction = () => {
      if (audio && audio.paused) {
        audio.muted = false;
        audio
          .play()
          .catch((error) => console.error("Audio play failed:", error));

        // Remove event listeners after playing
        document.removeEventListener("mousemove", handleUserInteraction);
        document.removeEventListener("click", handleUserInteraction);
        document.removeEventListener("touchstart", handleUserInteraction);
      }
    };

    // Add event listeners
    document.addEventListener("mousemove", handleUserInteraction);
    document.addEventListener("click", handleUserInteraction);
    document.addEventListener("touchstart", handleUserInteraction);

    return () => {
      document.removeEventListener("mousemove", handleUserInteraction);
      document.removeEventListener("click", handleUserInteraction);
      document.removeEventListener("touchstart", handleUserInteraction);
    };
  }, []);

  return (
    <audio ref={audioRef} loop muted>
      <source src={bgMusic} type="audio/mp3" />
      Your browser does not support the audio element.
    </audio>
  );
};

export default BackgroundAudio;
